
import { Card, CardContent } from '@/components/ui/card';
import { Label } from '@/components/ui/label';
import { Switch } from '@/components/ui/switch';

interface PEOGuidanceSwitchProps {
  needsGuidance: boolean;
  onToggleGuidance: (checked: boolean) => void;
}

export const PEOGuidanceSwitch = ({
  needsGuidance,
  onToggleGuidance,
}: PEOGuidanceSwitchProps) => {
  return (
    <Card>
      <CardContent className="pt-6">
        <div className="flex items-center justify-between">
          <Label htmlFor="needs_guidance">
            I have specific PEO providers to include or exclude
          </Label>
          <Switch
            id="needs_guidance"
            checked={needsGuidance}
            onCheckedChange={onToggleGuidance}
          />
        </div>
      </CardContent>
    </Card>
  );
};
